export * from '../stile-shared/configs/gatsby-browser';
